__turbopack_context__.v({
  "button": "x9LuxG_button",
  "button-selected": "x9LuxG_button-selected",
  "combo-box-wrapper": "x9LuxG_combo-box-wrapper",
  "dropdown": "x9LuxG_dropdown",
  "error-message": "x9LuxG_error-message",
  "footer": "x9LuxG_footer",
  "icon": "x9LuxG_icon",
  "icon-chevron": "x9LuxG_icon-chevron",
  "icon-search": "x9LuxG_icon-search",
  "label": "x9LuxG_label",
  "label-disabled": "x9LuxG_label-disabled",
  "message": "x9LuxG_message",
  "open": "x9LuxG_open",
  "option-button": "x9LuxG_option-button",
  "option-wrapper": "x9LuxG_option-wrapper",
  "placeholder": "x9LuxG_placeholder",
  "scroll-container": "x9LuxG_scroll-container",
  "search": "x9LuxG_search",
  "search-wrapper": "x9LuxG_search-wrapper",
  "select-hidden": "x9LuxG_select-hidden",
  "wrapper": "x9LuxG_wrapper",
  "wrapper-disabled": "x9LuxG_wrapper-disabled",
});
